import React from 'react'
import { Pane, Tablist, majorScale } from 'evergreen-ui'

const NavigationBar: React.FC = ({ children }) => (
  <Pane
    flex="none"
    background="white"
    borderTop="muted"
    borderBottom="default"
    paddingY={majorScale(1)}
    display="flex"
    justifyContent="center"
  >
    <Tablist>{children}</Tablist>
  </Pane>
)

export default NavigationBar
